import { AutocompleteEdit } from "../Controls/Autocomplete";
import { Checkboxes } from "../Controls/Checkboxes/Checkboxes";
import { ColorPicker } from "../Controls/ColorPicker/ColorPicker";
import { DatePicker } from "../Controls/DatePicker";
import { Edit } from "../Controls/Edit";
// re-import from ./Attributes fails
import { IndividualControl } from "../Controls/Individual/IndividualControl";
import { Info } from "../Controls/Info";
import { InfoValues } from "../Controls/InfoValues";
import { Radios } from "../Controls/Radios/Radios";
import { Select } from "../Controls/Select/Select";
import { SingleOptionCheckbox } from "../Controls/SingleOptionBool";
import { SliderControl } from "../Controls/Slider";
import { Substructure } from "../Controls/Substructure";
import { TableControl } from "../Controls/Table";
import { ThumbnailControl } from "../Controls/Thumbnail";
import { LayoutControlType } from "../layouts/LayoutControlType";
export const ControlComponents = {
    [LayoutControlType.Autocomplete]: AutocompleteEdit,
    [LayoutControlType.Checkboxes]: Checkboxes,
    [LayoutControlType.ColorPicker]: ColorPicker,
    [LayoutControlType.Datepicker]: DatePicker,
    [LayoutControlType.Edit]: Edit,
    [LayoutControlType.Slider]: SliderControl,
    [LayoutControlType.Individual]: IndividualControl,
    [LayoutControlType.Info]: Info,
    [LayoutControlType.InfoValues]: InfoValues,
    [LayoutControlType.Radios]: Radios,
    [LayoutControlType.Select]: Select,
    [LayoutControlType.SingleCheckbox]: SingleOptionCheckbox,
    [LayoutControlType.Substructure]: Substructure,
    [LayoutControlType.Thumbnail]: ThumbnailControl,
    [LayoutControlType.Table]: TableControl,
};
//# sourceMappingURL=ControlComponents.js.map